import React, { useState, useMemo, useEffect } from "react";

export default function RoomBookingCard(props) {

	const {
	    booking,
	    workplaceActivities
	} = props;
	
	
	const activityMap = useMemo(function () {

	    const map = {};

	    if (workplaceActivities &&
	        workplaceActivities.length > 0) {
				console.log('Activitoies');
			console.log(workplaceActivities)
	        workplaceActivities.forEach(function (a) {

	            map[a.id] = a;
	        });
	    }

	    return map;

	}, [workplaceActivities]);

	function resolveActivity(record) {
        console.log(record);
	    if (!record || !record.activityId) {

	        return {
	            label: "No Activity",
	            background: "#999"
	        };
	    }

	    const activity =
	        activityMap[record.activityId];

	    if (!activity) {

	        return {
	            label: "Unknown",
	            background: "#666"
	        };
	    }

	    return {
	        label: activity.name,
	        background:
	            activity.color ||
	            activity.colour ||
	            "#5a9bd6"
	    };
	}

    function getBookingStatus(h) {

        if (h.bookingStatus === 1) {

            return {
                label: "Booked",
                color: "#5a9bd6"
            };
        }

        if (h.bookingStatus === 2) {

            return {
                label: "No Show",
                color: "#f97316"
            };
        }

        if (h.bookingStatus === 3) {

            return {
                label: "Ghost",
                color: "#a855f7"
            };
        }

        return null;
    }

    var resolved =
        resolveActivity(booking);

    var bookingStatus =
        getBookingStatus(booking);

    var used =
        booking.capacityUsed || 0;

    var cap =
        booking.capacity || 0;

    var pct =
        cap > 0
            ? Math.round(
                (used / cap) * 100
            )
            : 0;

    return (

        <div
            style={{
                background: "#ffffff",
                border: "1px solid #dfe3e8",
                borderRadius: "12px",
                minHeight: "110px",
                display: "grid",
                gridTemplateColumns:
                    "130px 1fr",
                overflow: "hidden",
                boxShadow:
                    "0 2px 10px rgba(0,0,0,0.06)",
                transition:
                    "all 0.25s ease"
            }}
        >

            {/* LEFT */}

            <div
                style={{
                    padding: "14px",
                    borderRight:
                        "1px solid #eef1f4",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    background:
                        "rgba(90,155,214,0.02)"
                }}
            >

                <div>

                    <div
                        style={{
                            fontSize: "18px",
                            marginBottom: "14px",
                            color: "#64748b",
                            fontWeight: "700"
                        }}
                    >
                        {String(booking.hour || 0)
                            .padStart(2, "0")}
                        :00
                    </div>

                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            marginBottom: "10px"
                        }}
                    >

                        <div
                            style={{
                                width: "10px",
                                height: "10px",
                                borderRadius: "50%",
                                background:
                                    resolved.background
                            }}
                        />

                        <div
                            style={{
                                fontSize: "13px",
                                color: "#666",
                                fontWeight: "500"
                            }}
                        >
                            {resolved.label}
                        </div>

                    </div>

                </div>

                <div
                    style={{
                        fontSize: "12px",
                        color: "#64748b",
                        fontWeight: "500"
                    }}
                >
                    {used}/{cap} • {pct}%
                </div>

            </div>

            {/* RIGHT */}

            <div
                style={{
                    padding: "14px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between"
                }}
            >

                <div>

                    {bookingStatus && (

                        <div
                            style={{
                                display: "inline-block",
                                background:
                                    bookingStatus.color,
                                color: "#fff",
                                borderRadius:
                                    "999px",
                                padding:
                                    "4px 10px",
                                fontSize: "10px",
                                marginBottom: "14px",
                                width: "100px",
                                textAlign: "center",
                                fontWeight: "700",
                                letterSpacing: "0.5px",
                                boxShadow:
                                    "0 2px 8px rgba(0,0,0,0.08)"
                            }}
                        >
                            {bookingStatus.label}
                        </div>

                    )}

                    {booking.bookingTitle && (

                        <div>

                            <div
                                style={{
                                    fontSize: "14px",
                                    fontWeight: "700",
                                    marginBottom: "6px",
                                    lineHeight: "19px",
                                    color: "#2b2b2b"
                                }}
                            >
                                {booking.bookingTitle}
                            </div>

                            {booking.bookedBy && (

                                <div
                                    style={{
                                        fontSize: "12px",
                                        color: "#64748b",
                                        marginBottom: "10px",
                                        fontWeight: "500"
                                    }}
                                >
                                    {booking.bookedBy}
                                </div>

                            )}

                            {booking.spaceName && (

                                <div
                                    style={{
                                        fontSize: "11px",
                                        color: "#888"
                                    }}
                                >
                                    {booking.spaceName}
                                </div>

                            )}

                        </div>

                    )}

                </div>

            </div>

        </div>
    );
}